import { Question } from '../types/assessment';

export const depressionQuestions: Question[] = [
  {
    id: 'phq9_intro',
    text: 'Over the last 2 weeks, how often have you been bothered by any of the following problems?',
    type: 'text',
    category: 'depression',
    subcategory: 'phq9',
    required: false,
    validationRules: []
  },
  {
    id: 'phq9_interest',
    text: 'Little interest or pleasure in doing things',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'phq9',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'phq9_mood',
    text: 'Feeling down, depressed, or hopeless',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'phq9',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'phq9_sleep',
    text: 'Trouble falling or staying asleep, or sleeping too much',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'phq9',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'phq9_energy',
    text: 'Feeling tired or having little energy',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'phq9',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'phq9_appetite',
    text: 'Poor appetite or overeating',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'phq9',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'phq9_self_esteem',
    text: 'Feeling bad about yourself - or that you are a failure or have let yourself or your family down',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'phq9',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'phq9_concentration',
    text: 'Trouble concentrating on things, such as reading the newspaper or watching television',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'phq9',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'phq9_psychomotor',
    text: 'Moving or speaking so slowly that other people could have noticed. Or the opposite - being so fidgety or restless that you have been moving around a lot more than usual',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'phq9',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1 },
      { value: 2, label: 'More than half the days', score: 2 },
      { value: 3, label: 'Nearly every day', score: 3 }
    ]
  },
  {
    id: 'phq9_suicidal_ideation',
    text: 'Thoughts that you would be better off dead, or of hurting yourself',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'phq9',
    required: true,
    options: [
      { value: 0, label: 'Not at all', score: 0 },
      { value: 1, label: 'Several days', score: 1, triggerConditions: ['suicide_risk_low'] },
      { value: 2, label: 'More than half the days', score: 2, triggerConditions: ['suicide_risk_moderate'] },
      { value: 3, label: 'Nearly every day', score: 3, triggerConditions: ['suicide_risk_high'] }
    ]
  },
  {
    id: 'phq9_functioning',
    text: 'If you checked off any problems, how difficult have these problems made it for you to do your work, take care of things at home, or get along with other people?',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'phq9',
    required: true,
    condition: {
      dependsOn: 'any_phq9_positive',
      operator: 'equals',
      value: true
    },
    options: [
      { value: 0, label: 'Not difficult at all', score: 0 },
      { value: 1, label: 'Somewhat difficult', score: 1 },
      { value: 2, label: 'Very difficult', score: 2 },
      { value: 3, label: 'Extremely difficult', score: 3 }
    ]
  },
  // Additional depression-related questions
  {
    id: 'depression_duration',
    text: 'How long have you been experiencing these symptoms?',
    type: 'multiple-choice',
    category: 'depression',
    subcategory: 'history',
    required: true,
    options: [
      { value: 'less-than-2-weeks', label: 'Less than 2 weeks' },
      { value: '2-4-weeks', label: '2-4 weeks' },
      { value: '1-3-months', label: '1-3 months' },
      { value: '3-6-months', label: '3-6 months' },
      { value: '6-months-1-year', label: '6 months to 1 year' },
      { value: 'more-than-1-year', label: 'More than 1 year' },
      { value: 'on-and-off', label: 'On and off for years' }
    ]
  },
  {
    id: 'depression_triggers',
    text: 'What do you think might have triggered or contributed to these feelings? (Select all that apply)',
    type: 'multi-select',
    category: 'depression',
    subcategory: 'triggers',
    required: false,
    options: [
      { value: 'major-life-change', label: 'Major life change (move, job, relationship)' },
      { value: 'loss-grief', label: 'Loss or grief' },
      { value: 'work-stress', label: 'Work-related stress' },
      { value: 'relationship-issues', label: 'Relationship problems' },
      { value: 'financial-stress', label: 'Financial difficulties' },
      { value: 'health-problems', label: 'Health problems' },
      { value: 'family-history', label: 'Family history of depression' },
      { value: 'seasonal-changes', label: 'Seasonal changes' },
      { value: 'medication-changes', label: 'Medication changes' },
      { value: 'substance-use', label: 'Alcohol or drug use' },
      { value: 'no-clear-trigger', label: 'No clear trigger' },
      { value: 'unsure', label: 'Not sure' }
    ]
  }
]; 